import React, { useState } from 'react';
import { newAnswer, ANSWER_PALETTE } from '../utils/workflowTree';
import WorkflowStepList from './WorkflowStepList';

/**
 * Décision dans l'éditeur. La CARTE ne contient que la question + les réponses (pills).
 * La branche de la réponse active se rend en LANE, SOUS la carte (frère, jamais imbriquée).
 */
export default function WorkflowDecisionTabs({ node, onChange, onRemove, depth, dragHandle }) {
  const answers = node.answers || [];
  const [active, setActive] = useState(answers[0]?.id || null);

  const setAnswers = (next) => onChange({ answers: next });
  const addAnswer = () => { const a = newAnswer(answers.length); setAnswers([...answers, a]); setActive(a.id); };
  const updateAnswer = (id, patch) => setAnswers(answers.map((a) => (a.id === id ? { ...a, ...patch } : a)));
  const removeAnswer = (id) => {
    if (!window.confirm('Supprimer cette réponse et ses étapes ?')) return;
    const next = answers.filter((a) => a.id !== id);
    setAnswers(next);
    if (active === id) setActive(next[0]?.id || null);
  };
  const setBranchSteps = (id, steps) => setAnswers(answers.map((a) => (a.id === id ? { ...a, steps } : a)));

  const activeAnswer = answers.find((a) => a.id === active) || answers[0];

  return (
    <>
      <div className="wf-card decision">
        <div className="wf-card-head">
          <span className="wf-type decision">Décision</span>
          <input className="wf-edit-title" placeholder="Quelle est la question ?" value={node.question || ''}
            onChange={(e) => onChange({ question: e.target.value })} />
          <button className="wf-grip" title="Glisser" aria-label="Réordonner" {...(dragHandle || {})}>⠿</button>
        </div>
        <div className="wf-answers">
          {answers.map((a) => (
            <button key={a.id} className={`wf-pill ${active === a.id ? 'on' : ''}`}
              style={active === a.id ? { background: a.color, borderColor: a.color } : { borderColor: a.color, color: a.color }}
              onClick={() => setActive(a.id)}>
              {a.label || 'réponse'}<span className="wf-pill-count">· {(a.steps || []).length}</span>
            </button>
          ))}
          <button className="wf-pill-add" onClick={addAnswer}>+ réponse</button>
          <button className="btn-icon delete wf-card-del" title="Supprimer la décision" onClick={onRemove}>🗑️</button>
        </div>
      </div>

      {activeAnswer && (
        <div className="wf-lane" style={{ borderColor: activeAnswer.color || 'var(--border-default)' }}>
          <div className="wf-lane-head">
            <span className="wf-lane-label" style={{ background: activeAnswer.color || '#64748b' }}>
              <input type="color" className="wf-swatch" value={activeAnswer.color || ANSWER_PALETTE[0]}
                onChange={(e) => updateAnswer(activeAnswer.id, { color: e.target.value })} title="Couleur de la branche" />
            </span>
            <input className="wf-lane-rename" placeholder="Libellé (ex. Oui)" value={activeAnswer.label || ''}
              onChange={(e) => updateAnswer(activeAnswer.id, { label: e.target.value })} />
            <button className="btn-icon delete" title="Supprimer la réponse" onClick={() => removeAnswer(activeAnswer.id)}>🗑️</button>
          </div>
          <WorkflowStepList nodes={activeAnswer.steps || []} onChange={(steps) => setBranchSteps(activeAnswer.id, steps)} depth={depth + 1} />
        </div>
      )}
    </>
  );
}
